// extracted by mini-css-extract-plugin
export default {"checkbox":"ModalSelectColumns_checkbox__Kw2DG"};